import React, { useEffect, useState } from "react";
import "../css/wb_mis_report.css";
import Import from "../Assets/images/import.png";
import Export from "../Assets/images/export.png";
import excelIcon from "../Assets/images/excel.png";
import Search from "../Assets/images/search.png";
import { apiCall } from "../services/authServieces";
import CustomDateRangePicker from "../components/CustomDatePicker";
import { useUIContext } from "../context";
import { formatDate } from "../utils/helper";
import { ClipLoader } from "react-spinners";
import { subMonths } from "date-fns";

const WbMisReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [showPagi, setShowPagi] = useState(false);
  const [dealerList, setDealerList] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [selectedDealer, setSelectedDealer] = useState("");
  const [networkType, setNetworkType] = useState("");
  const [mobilesrch, setmobilesrch] = useState("");
  const itemsPerPage = 10;
  const { dateRanges } = useUIContext();
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  let storedData = localStorage.getItem('user-cred');
  const dataObj = JSON.parse(storedData);

  // Get network type from token
  useEffect(() => {
    if (dataObj?.user?.networkType) {
      setNetworkType(dataObj.user.networkType);
    }
  }, []);

  // Fetch dealer list when network type is Main Dealer
  const fetchDealerList = async () => {
    if (networkType === "Main Dealer") {
      try {
        setLoading(true);
        const res = await apiCall({
          endpoint: "api/reports/get-dealer-list",
          method: "GET",
        });

        if (res.success && res.data) {
          setDealerList(res.data);
        }
      } catch (error) {
        console.error("Error fetching dealer list:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (networkType === "Main Dealer") {
      fetchDealerList();
    }
  }, [networkType]);

  // Get today's date and calculate two months ago
  const today = new Date();
  const twoMonthsAgo = subMonths(today, 2);

  const isDateWithinLastTwoMonths = (date) => {
    const reportDate = new Date(date);
    return reportDate >= twoMonthsAgo && reportDate <= today;
  };

  const fetchData = async (page) => {
    try {
      setLoading(true);

      const dates = dateRanges.one.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      });

      let endpoint = "";
      let params = new URLSearchParams({
        startDate: dates[0] || undefined,
        endDate: dates[1] || undefined,
        page: page,
        limit: itemsPerPage,
      });

      // Check filter type and set appropriate endpoint and parameters
      if (filterType === "all") {
        if (networkType === "Main Dealer") {
          // For Main Dealer - get aggregated data of all dealers
          endpoint = "api/reports/get-main-dealer-mis-report";
          params.append("userId", dataObj.user.userId);
        } else {
          // For individual dealer - get own data
          // endpoint = "api/reports/get-individual-mis-report";
          // params.append("userId", dataObj.user.userId);

          endpoint = "api/reports/get-main-dealer-mis-report";

          if (dataObj.user.userId=='hondasalesapi'){

          endpoint = "api/reports/get-main-admin-total-mis-report";
          params.append("userId", dataObj.user.adminId);

          }else{

            params.append("userId", dataObj.user.userId);

          }

        }
      } else if (filterType === "dealer" && selectedDealer) {
        // For specific dealer data
        // endpoint = "api/reports/get-individual-mis-report";
        // params.append("userId", selectedDealer);
        endpoint = "api/reports/get-main-dealer-mis-report";
        params.append("userId", dataObj.user.userId);
      }

      if (dates.length && endpoint) {
        const res = await apiCall({
          endpoint: `${endpoint}?${params.toString()}`,
          method: "GET",
        });

        if (res.success && res.data && res.data.length > 0) {
          const transformedData = res.data.map(item => ({
            formattedDate: formatDate(item.date),
            date: item.date,
            values: [
              item.total,
              item.delivered,
              item.failed,
              item.hsm_seen,
              item.session_send,
              item.session_delivered,
              item.session_failed
            ],
            imageSrc: Import,
          }));

          setReportData(transformedData);
          setTotalPages(Math.ceil(res.total / itemsPerPage));
          setShowPagi(res.total > itemsPerPage);
        } else {
          setReportData([]);
          setTotalPages(0);
          setShowPagi(false);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [filterType, selectedDealer]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page);
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchData(1);
  };

  const handleFilterChange = (value) => {
    setFilterType(value);
    setSelectedDealer("");
    setCurrentPage(1);
  };

  const handleDealerChange = (dealerId) => {
    setSelectedDealer(dealerId);
    setCurrentPage(1);
  };

  const createPagination = () => {
    const pagesToShow = 1;
    let pages = [];

    if (totalPages > 1) {
      pages.push(1);
      if (currentPage > pagesToShow + 2) pages.push(null);

      for (let i = Math.max(2, currentPage - pagesToShow); i <= Math.min(totalPages - 1, currentPage + pagesToShow); i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - pagesToShow - 1) pages.push(null);
      pages.push(totalPages);
    }

    return pages;
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env.REACT_APP_API_URL;

      let endpoint = "";
      const dates = dateRanges.one.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      });

      const params = new URLSearchParams();
      if (dates.length) {
        params.append("startDate", dates[0] || "");
        params.append("endDate", dates[1] || "");
      }

      // Set endpoint based on filter type
      if (filterType === "all") {
        if (networkType === "Main Dealer") {
          endpoint = `${baseURL}/api/reports/export-main-dealer-mis-report`;
          params.append("userId", dataObj.user.userId);
        } else {
          
          endpoint = `${baseURL}/api/reports/export-individual-mis-report`;
          if(dataObj.user.userId=='hondasalesapi'){

            params.append("userId", dataObj.user.adminId);

          }else{

            params.append("userId", dataObj.user.userId);
          }
        }
      } else if (filterType === "dealer" && selectedDealer) {
        endpoint = `${baseURL}/api/reports/export-individual-mis-report`;
        params.append("userId", selectedDealer);
      }

      endpoint = `${endpoint}?${params.toString()}`;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to export MIS Report");

      const blob = await response.blob();

      let filename = "MIS_Report.csv";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = decodeURIComponent(match[1]);
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackBar({
        open: true,
        severity: "success",
        message: "MIS Report downloaded successfully",
      });
    } catch (error) {
      console.error("Export Error:", error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Failed to download MIS Report",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (date) => {
    try {
      setLoading(true);
      const headers = ['User Name', 'Dealer Code', 'Mobile', 'Message', 'Message Type', 'Message Category', 'Status', 'Date', 'Error Code'];
      const csvRows = [];
      csvRows.push(headers.join(','));

      let downloadDate = date;
      if (!downloadDate && reportData.length > 0) {
        downloadDate = reportData[0].date;
      }

      const res = await apiCall({
        endpoint: `report/download/date?date=${downloadDate}`,
        method: "GET",
      });

      const escapeCSVValue = (value) => {
        if (typeof value === 'string') {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      };

      res.data.forEach((item) => {
        const row = [
          escapeCSVValue(item.created_by),
          "",
          escapeCSVValue(item.sender_mobile),
          escapeCSVValue(item.msg),
          escapeCSVValue(item.msg_type),
          escapeCSVValue(item.temp_category),
          escapeCSVValue(item.delivery_status),
          escapeCSVValue(item.send_date),
          escapeCSVValue(item.source)
        ];
        csvRows.push(row.join(','));
      });

      const csvString = csvRows.join('\n');
      const csvWithBom = "\uFEFF" + csvString;
      const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'mis_report.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="Mis_report_contian">
        <h4 className="Head_title MisReportTitle mis_report">
          <div className="mis_report_container mis_report_container_new">

            {/* Date Range + Search */}
            <div className="DateRangeContain data_mis_report data_mis_report_new">
              <CustomDateRangePicker rangeKey="one" />
              <button type="button" className="SearchDateRange" onClick={handleSearch}>
                <img src={Search} alt="Search" />
              </button>
            </div>

            {/* Title */}
            <span className="mis_report_title">MIS Report</span>
        
              {/* Excel Export */}
              <button type="button" className="ExcelIconContain" onClick={handleExport}>
                <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
              </button>

              {/* Custom Filters + Search */}
              <div className="custom_SearchContain">
                <div className="custom_filter_section me-5">
                  <select
                    className="custom_dropdown"
                    value={filterType}
                    onChange={(e) => handleFilterChange(e.target.value)}
                  >
                    <option value="all">All</option>
                    {networkType === "Main Dealer" && (
                      <option value="dealer">Dealer Wise</option>
                    )}
                  </select>

                  {filterType === "dealer" && networkType === "Main Dealer" && (
                    <select
                      className="custom_dropdown"
                      value={selectedDealer}
                      onChange={(e) => handleDealerChange(e.target.value)}
                      disabled={dealerList.length === 0}
                    >
                      <option value="">Select Dealer</option>
                      {dealerList.map((dealer, index) => (
                        <option key={index} value={dealer.user_id}>
                          {dealer.user_id}
                        </option>
                      ))}
                    </select>
                  )}
                </div>

                {/* <div className="custom_search_box me-5">
        <input
          type="text"
          placeholder="Search by mobile..."
          value={mobilesrch}
          onChange={(e) => setmobilesrch(e.target.value)}
        />
        <button type="button" className="custom_search_btn">
          <img src={Search} alt="Search" />
        </button>
      </div> */}
              </div>
            
          </div>
        </h4>


        <div className="Mis_report_Card122">
          <div className="table_contain tMisReport">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  <th>Sent Date</th>
                  <th>HSM Send</th>
                  <th>HSM Delivered</th>
                  <th>HSM Failed</th>
                  <th>HSM Seen</th>
                  <th>SMS Send</th>
                  <th>SMS Delivered</th>
                  <th>SMS Failed</th>
                </tr>
              </thead>
              <tbody>
                {reportData.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="tableDataCenterPosition">
                      No data available
                    </td>
                  </tr>
                ) : (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.formattedDate}</td>
                      {item.values.map((value, i) => (
                        <td key={i}>{value}</td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {showPagi && (
          <div className="pagination">
            {createPagination().map((page, index) => (
              page === null ? (
                <span key={index} className="ellipsis">...</span>
              ) : (
                <button
                  key={index}
                  className={`page-button ${currentPage === page ? 'active' : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              )
            ))}
          </div>
        )}
      </div>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default WbMisReport;